/**
 * SiteFooter — slim global footer mounted in RootLayout so legal + pricing
 * links are reachable from every page (previously only via direct URL).
 *
 * Suppressed on:
 *   - /play   : full-screen game canvas (its own toolbar / embedded pill)
 *   - /admin  : operator dashboard with its own chrome
 *   - pages that already render their own footer (Pricing, Account, the
 *     legal pages via LegalShell, and the League detail page) — avoids
 *     duplicate footer rows.
 */
import { Link, useLocation } from "react-router-dom";

const SUPPRESSED = new Set<string>([
  "/play",
  "/admin",
  "/pricing",
  "/terms",
  "/privacy",
  "/refund",
  "/account",
]);

export function SiteFooter() {
  const { pathname } = useLocation();
  // League detail (/leagues/:id) has its own footer; /leagues index does not.
  if (SUPPRESSED.has(pathname) || pathname.startsWith("/leagues/")) return null;

  return (
    <footer className="border-t border-white/10 px-4 py-6 text-center text-xs text-white/60">
      <nav className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <Link to="/pricing" className="hover:text-white hover:underline">Pricing</Link>
        <Link to="/terms" className="hover:text-white hover:underline">Terms</Link>
        <Link to="/privacy" className="hover:text-white hover:underline">Privacy</Link>
        <Link to="/refund" className="hover:text-white hover:underline">Refund</Link>
        <a href="mailto:vbraju@thoughtplanet.com" className="hover:text-white hover:underline">Support</a>
      </nav>
      <p className="mt-2">
        Curvle is operated by Thoughtplanet Advisory Services LLP, India.
      </p>
    </footer>
  );
}
